import { UserWithGroups } from "../types/accountManagement.types";

let cachedUsers: UserWithGroups[] | null = null;

export const getCachedUsers = (): UserWithGroups[] | null => cachedUsers;

export const setCachedUsers = (users: UserWithGroups[]): void => {
  cachedUsers = users;
};

export const invalidateUsersCache = (): void => {
  cachedUsers = null;
};
